import { Outlet } from "react-router-dom";
import Navbar from "../../components/Navbar";
import { useState, useEffect } from "react";
import { useAppSelector } from "../../redux/hooks";
import { RootState } from "../../redux/store";
import LogoutModal from "../../components/LogoutModal";
import { checkTokenExpiration } from "../../redux/thunk";
import axios from "axios";
import { SidebarInset, SidebarProvider } from "../../components/ui/sidebar";
import { AppSidebar } from "../../components/ui/AppSidebar";
import { getSalesOfficerNavItems } from "../../config/navigation";
import ChangePassword from "../../components/modals/ChangePassword";

export const SalesOfficerBasePage = () => {
  const { token, uid } = useAppSelector((store: RootState) => store.auth);
  const [role, setRole] = useState("");
  const [modals, setModals] = useState({
    logout: false,
    changePassword: false,
  });

  useEffect(() => {
    if (token) {
      checkTokenExpiration();
    }
  }, [token]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      checkTokenExpiration();
    }, 900000); // 15 minutes

    return () => clearInterval(intervalId);
  }, []);

  // useEffect(() => {
  //   getAllAdmins();
  // }, []);

  // const getAllAdmins = async () => {
  //   try {
  //     const res = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/get-admins-except-superadmin`,
  //     );
  //     const filteredAdmin = res.data.filter((admin: any) => admin.id === uid);
  //     setRole(filteredAdmin[0]?.pagesToDisplay || "");
  //   } catch (error) {}
  // };

  const openModal = (modalName: keyof typeof modals) => {
    setModals((prevState) => ({ ...prevState, [modalName]: true }));
  };

  const closeModal = (modalName: keyof typeof modals) => {
    setModals((prevState) => ({ ...prevState, [modalName]: false }));
  };

  const navItems = getSalesOfficerNavItems();

  return (
    <SidebarProvider>
      <AppSidebar
        items={navItems}
        onLogout={() => openModal("logout")}
        onChangePassword={() => openModal("changePassword")}
      />
      <SidebarInset>
        <Navbar />
        <main className="flex-1 overflow-x-hidden px-4 2xl:px-8 pb-8 pt-4">
          <Outlet />
        </main>
      </SidebarInset>

      {modals.logout && <LogoutModal closeModal={() => closeModal("logout")} />}
      {modals.changePassword && (
        <ChangePassword
          accountOfficer
          setShowChangePassword={() => closeModal("changePassword")}
        />
      )}
    </SidebarProvider>
  );
};

export default SalesOfficerBasePage;
